export const GuidanceText = (props) => {
    if (props.startDate && props.endDate) return 'Dates selected'
    if (props.warning) return props.warning
    return props.startDate ? 'Select Check Out Date' : 'Select Check In Date'
  } 